<template lang="pug">
.dawnSelect__content-table-wrapper
  .dawnSelect__content-table-body-wrapper
    .dawnSelect__content-table-row-wrapper
      .dawnSelect__content-table-image-wrapper(v-if='thumbnails')
        slot(name='image')
      .dawnSelect__content-table-content-wrapper
        slot(name='row1')
        slot(name='row2')
        slot(name='row3')
        slot(name='row4')
        slot(name='row5')
        slot(name='row6')
</template>

<script>

export default {
  name: 'ed-select-options',
  props: {
    thumbnails: Boolean
  }
}
</script>

<style lang="scss">
@import "~@/assets/sass/_variables.scss";

</style>



// WEBPACK FOOTER //
// selectOptions.vue?651ff18c